const getEnv = (key: string): string => {
  const value = import.meta.env[key]
  if (!value) {
    throw new Error(`Missing environment variable: ${key}`)
  }
  return value
}

export const cognitoConfig = {
  userPoolId: getEnv("VITE_COGNITO_USER_POOL_ID"),
  userPoolClientId: getEnv("VITE_COGNITO_USER_POOL_CLIENT_ID"),
}

export const API_KEY = getEnv("VITE_API_KEY")